<template>
	<b-navbar type="dark" variant="dark" sticky>
		<b-navbar-brand href="#" variant="light">
			Word Freq
		</b-navbar-brand>
		<b-navbar-nav class="ml-auto align-items-center">
			<!-- <b-button class="mr-2" @click="openCite" variant="success">Cite</b-button> -->
			<!--<b-button class="mr-2" @click="openHelp" variant="info">Help</b-button>-->
			<div class="mr-2 text-white">{{ saveStatus }}</div>
				<b-button v-if="saveStatus !== 'Saved'" class="mr-2 btn btn-success" @click="save">Save</b-button>
			<b-button class="btn btn-danger" v-if="projectOpen" @click="$store.dispatch('resetStore')">
				Clear
			</b-button>
			<b-button id="tooltip-help" style="border-radius: 20px; width: 90px; margin-left: 6px; background-color: #21a5d5;" class="btn btn-info" @click="openHelp">Help</b-button>
			<b-tooltip style="width:400px !important;" target="tooltip-help" triggers="hover" placement="bottom">
						<h6>Click here to see help page</h6>
			</b-tooltip>
		</b-navbar-nav>
	</b-navbar>
</template>

<script>
import { mapGetters } from "vuex";
import { BNavbar, BNavbarBrand, BNavbarNav, BButton, BTooltip } from 'bootstrap-vue';

export default {
	name: 'TheNavbar',
	props: {
		projectOpen: Boolean
	},
	data() {
		return {
			isEditTitle: false,
			tempTitle: ""
		}
	},
	components: {
		BNavbar,
		BNavbarBrand,
		BNavbarNav,
		BButton,
		BTooltip
	},
	computed: {
		...mapGetters('metadata', {
			title: 'getTitle'
		}),
		...mapGetters('__tera_file_sync', {
      saveStatus: 'getSaveStatus'
    })
	},
	methods: {
		// openCite() {
		// 	// TODO: Open citation page
		// },
		openHelp() {
			// Open help page
			window.open('https://tera-tools.com/help/word-freq','_blank')
		},
		save() {
			this.$teraSync.saveState();
		},
		saveTitle() {
			this.$store.commit('metadata/setTitle', this.tempTitle);
			this.isEditTitle = false;
		},
		cancelEdit() {
			this.isEditTitle = false;
			this.tempTitle = this.title;
		}
	}
}
</script>
<style scoped>
.navbar {
	background-image: linear-gradient(#6880b5, #465b8b, #5971a5);
	color: #dcdee5;
}
</style>